/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricValueAggregatedValuesDto
 */
export interface MetricValueAggregatedValuesDto {
    /**
     * Sum of values
     * @type {number}
     * @memberof MetricValueAggregatedValuesDto
     */
    sum?: number;
    /**
     * Minimum value
     * @type {number}
     * @memberof MetricValueAggregatedValuesDto
     */
    min?: number;
    /**
     * Maximum value
     * @type {number}
     * @memberof MetricValueAggregatedValuesDto
     */
    max?: number;
    /**
     * Latest value recorded
     * @type {number}
     * @memberof MetricValueAggregatedValuesDto
     */
    latest?: number;
}

/**
 * Check if a given object implements the MetricValueAggregatedValuesDto interface.
 */
export function instanceOfMetricValueAggregatedValuesDto(value: object): value is MetricValueAggregatedValuesDto {
    return true;
}

export function MetricValueAggregatedValuesDtoFromJSON(json: any): MetricValueAggregatedValuesDto {
    return MetricValueAggregatedValuesDtoFromJSONTyped(json, false);
}

export function MetricValueAggregatedValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValueAggregatedValuesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sum': json['sum'] == null ? undefined : json['sum'],
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
        'latest': json['latest'] == null ? undefined : json['latest'],
    };
}

export function MetricValueAggregatedValuesDtoToJSON(json: any): MetricValueAggregatedValuesDto {
    return MetricValueAggregatedValuesDtoToJSONTyped(json, false);
}

export function MetricValueAggregatedValuesDtoToJSONTyped(value?: MetricValueAggregatedValuesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sum': value['sum'],
        'min': value['min'],
        'max': value['max'],
        'latest': value['latest'],
    };
}

